import type { FC } from 'react';
import { Pressable, StyleSheet, Text, type StyleProp, type ViewStyle } from 'react-native';
import { SvgIconType } from '@thermenresorts/icons';
import Colors from 'src/core/utils/Colors';
import Dimens from 'src/core/utils/Dimens';
import Fonts from 'src/core/utils/Fonts';
import Translations from 'src/core/utils/Translations';
import SvgIcon from 'src/presentation/components/atoms/SvgIcon';

interface Props {
	onPress: () => void;
	label?: string;
	style?: StyleProp<ViewStyle>;
}

const BackLink: FC<Props> = ({ onPress, label = Translations.goBack, style }) => {
	return (
		<Pressable style={[styles.row, style]} onPress={onPress}>
			<SvgIcon name={SvgIconType.chevronLeft} size={Dimens.iconSize10} tintColor={Colors.gray800} />
			<Text style={styles.label}>{label}</Text>
		</Pressable>
	);
};

const styles = StyleSheet.create({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		alignSelf: 'flex-start',
		gap: Dimens.gap8,
		height: Dimens.buttonHeight50,
		paddingRight: Dimens.padding12,
	},
	label: {
		fontFamily: Fonts.barlowMedium,
		fontSize: Dimens.fontSize12,
		fontWeight: Dimens.fontWeight500,
		letterSpacing: Dimens.letterSpacing060,
		lineHeight: Dimens.lineHeight16,
		color: Colors.gray800,
		textTransform: 'uppercase',
	},
});

export default BackLink;
